import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=26af5fce&"
import script from "./parts.vue?vue&type=script&lang=js&"
export * from "./parts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports